
import Base from './Base';


/**
 * 路线。根据业务认为n个poi点组成一条路线（实际应该是每两个poi点作为一条路线）
 *
 * @export
 * @class Route
 * @extends {Base}
 */
export default class Route extends Base {
  // doc: https://doc.oschina.net/xingchengzushou?t=144800
  schema = {
    key: String, // 路线唯一ID
    A_loc: Object, // 起点位置
    B_loc: Object, // 结束点位置
    error: String || null, // 规划路线是否失败
    routes: {
      geojson: Array, // 二维数组：描绘一条路线的所有坐标点
      duration: Number, // 驾驶时间，单位：秒
      distance: Number, // 路线距离，单位：米
      oils: Number // 驾驶油耗，单位：升
    },
    additional_lines: [ // 附加线路数据，产品需求
      {
        type: String, // 路线类型
        geojson: Array // 同routes.geojson
      }
    ]
  };

  static parseInput(obj) {
    if (obj.routes) {
      obj.routes.geojson = obj.routes.geojson.map(function (lngLat) {
        return [lngLat[1], lngLat[0]];
      });
    }

    if (obj.additional_lines) {
      obj.additional_lines = obj.additional_lines.map(function (item) {
        item.geojson = item.geojson.map(function (lngLat) {
          return [lngLat[1], lngLat[0]];
        });
        return item;
      });
    }

    return obj;
  }
}



// WEBPACK FOOTER //
// ./src/models/Route.js